import { filter, set } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box, // Import Box from @mui/material
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';
import { Title } from '@mui/icons-material';
import Iconify from '../components/Iconify'; // Import Iconify

import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';

import { HrconclaveListToolbar, HrconclaveListHead, HrconclaveMoreMenu } from '../sections/reports';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'title', label: 'Title', alignRight: false },
  { id: 'subTitle1', label: 'Subtitle 1', alignRight: false },
  { id: 'subTitle2', label: 'Subtitle 2', alignRight: false },
  { id: 'columns', label: 'Columns', alignRight: false },
  { id: 'rows', label: 'Rows', alignRight: false },
  { id: 'cardData', label: 'Hall Data', alignRight: false },
  { id: 'boardRoomCard', label: 'Board Room Card', alignRight: false },
  { id: 'images', label: 'Images', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  let filteredArray = stabilizedThis.map((el) => el[0]);

  if (query) {
    filteredArray = filteredArray.filter((item) => {
      const searchTerm = query.toLowerCase();
      return (
        String(item.year).includes(searchTerm) || // Convert year to string for includes
        (item.image && item.image.toLowerCase().includes(searchTerm)) ||
        (item.form && item.form.toLowerCase().includes(searchTerm)) ||
        (item.images && item.images.some(img => img.toLowerCase().includes(searchTerm))) // Check if any image includes the search term
      );
    });
  }

  return filteredArray;
}

export default function RentalDetials() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('year'); // Sort by year
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // State for Hrconclave
  const [hrconclaves, setHrconclaves] = useState([]);
  const [editingHrconclaveId, setEditingHrconclaveId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedHrconclave, setSelectedHrconclave] = useState(null);

  const [title, setTitle] = useState('');
const [subTitle1, setSubTitle1] = useState('');
const [subTitle2, setSubTitle2] = useState('');
// ===== TABLE COLUMNS =====
const [columns, setColumns] = useState([]);
const [newColumnGroup, setNewColumnGroup] = useState('');
const [newColumnSub, setNewColumnSub] = useState('');

// ===== TABLE ROWS =====
const [rows, setRows] = useState([]);
const [newRowLabel, setNewRowLabel] = useState('');
const [newRowValues, setNewRowValues] = useState(''); // comma separated
const [newRowHighlight, setNewRowHighlight] = useState(false);

// ===== CARD DATA =====
const [cardData, setCardData] = useState([]);
const [newCardTitle, setNewCardTitle] = useState('');
const [newCardItem, setNewCardItem] = useState('');

// ===== BOARD ROOM CARDS =====
const [boardRoomCard, setBoardRoomCard] = useState([]);
const [newDuration, setNewDuration] = useState('');
const [newBoardDetail, setNewBoardDetail] = useState('');


const [images, setImages] = useState([]);
const [newImageLink, setNewImageLink] = useState('');

  // Fetch Hrconclaves from the server on component mount
  useEffect(() => {
    fetchHrconclaves();
  }, []);

  const fetchHrconclaves = async () => {
    try {
      const response = await axios.get('https://cpccbe.org/api/rentaldetials');
      setHrconclaves(response.data);
    } catch (error) {
      console.error('Error fetching Hrconclaves:', error);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleViewhrconclave = (hrconclave) => {
    setSelectedHrconclave(hrconclave);
    setViewModalOpen(true);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = hrconclaves.map((n) => n._id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleOpenModal = (id) => {
    setEditingHrconclaveId(id || null);
    setTitle('');
  setSubTitle1('');
  setSubTitle2('');
  setImages([]);
  setNewImageLink('');
  setColumns([]);
setRows([]);
setCardData([]);
setBoardRoomCard([]);

   
    setOpenModal(true);

    if (id) {
      const item = hrconclaves.find((item) => item._id === id);
      if (item) {
        setTitle(item.title);
      setSubTitle1(item.subTitle1);
      setSubTitle2(item.subTitle2);
      setImages(item.images || []);
      setColumns(item.columns || []);
setRows(item.rows || []);
setCardData(item.cardData || []);
setBoardRoomCard(item.boardRoomCard || []);

       
      }
    }
  };






  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCloseViewModal = () => {
    setViewModalOpen(false);
    setSelectedHrconclave(null);
  };

  const handleAddHrconclave = async () => {
    try {
      const payload = {
  title,
  subTitle1,
  subTitle2,
  images,
  columns,
  rows,
  cardData,
  boardRoomCard
};

       await axios.post('https://cpccbe.org/api/rentals', payload);

      fetchHrconclaves();
      handleCloseModal();
    } catch (error) {
      console.error('Error adding rentaldetials:', error);
    }
  };

  const handleUpdateHrconclave = async () => {
    try {
      const payload = {
  title,
  subTitle1,
  subTitle2,
  images,
  columns,
  rows,
  cardData,
  boardRoomCard
};

      await axios.put(`https://cpccbe.org/api/rentaldetials/${editingHrconclaveId}`, payload);  // Corrected endpoint
      fetchHrconclaves();
      handleCloseModal();
    } catch (error) {
      console.error('Error updating rentaldetials:', error);
    }
  };

  const handleDeleteHrconclave = async (id) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      try {
        await axios.delete(`https://cpccbe.org/api/rentaldetials/${id}`);  // Corrected endpoint
        fetchHrconclaves();
      } catch (error) {
        console.error('Error deleting rentaldetials:', error);
      }
    }
  };

  const handleAddImageLink = () => {
    if (newImageLink.trim() !== '') {
      setImages([...images, newImageLink]);
      setNewImageLink('');
    }
  };

  const handleRemoveImageLink = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - hrconclaves.length) : 0;
  const filteredHrconclaves = applySortFilter(hrconclaves, getComparator(order, orderBy), filterName);

  const isHrconclaveNotFound = filteredHrconclaves.length === 0;

  return (
    <Page title="rentaldetials">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Rental Details
          </Typography>
          <Button variant="contained" onClick={() => handleOpenModal(null)} startIcon={<Iconify icon="eva:plus-fill" />}>
            New Rental Details
          </Button>
        </Stack>

        <Card>
          <HrconclaveListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <HrconclaveListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={hrconclaves.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
  {filteredHrconclaves
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    .map((row) => {
      const { _id, title, subTitle1, subTitle2, images, columns, rows, cardData, boardRoomCard } = row;

      return (
        <TableRow hover key={_id} tabIndex={-1} role="checkbox">
          {/* VIEW BUTTON */}
          <TableCell padding="checkbox">
            <IconButton aria-label="view" onClick={() => handleViewhrconclave(row)}>
              <Iconify icon="eva:eye-fill" />
            </IconButton>
          </TableCell>

          {/* BASIC INFO */}
          <TableCell align="left">{title}</TableCell>
          <TableCell align="left">{subTitle1}</TableCell>
          <TableCell align="left">{subTitle2}</TableCell>

          {/* IMAGES */}
          <TableCell align="left">
            {images && images.map((img, index) => (
              <Typography key={index} variant="caption" display="block">
                <a href={img} target="_blank" rel="noopener noreferrer">{img}</a>
              </Typography>
            ))}
          </TableCell>

          {/* COLUMNS */}
          <TableCell align="left">
            {columns && columns.map((col, index) => (
              <Typography key={index} variant="caption" display="block">
                {col.group} → {col.sub.join(', ')}
              </Typography>
            ))}
          </TableCell>

          {/* ROWS */}
          <TableCell align="left">
            {rows && rows.map((r, index) => (
              <Typography key={index} variant="caption" display="block">
                {r.label}: {r.values.join(', ')} {r.highlight ? '(Highlight)' : ''}
              </Typography>
            ))}
          </TableCell>

          {/* CARDS */}
          <TableCell align="left">
            {cardData && cardData.map((card, index) => (
              <Box key={index} mb={1}>
                <Typography variant="subtitle2">{card.title}</Typography>
                {card.items.map((item, idx) => (
                  <Typography key={idx} variant="caption" display="block">- {item}</Typography>
                ))}
              </Box>
            ))}
          </TableCell>

          {/* BOARD ROOM CARDS */}
          <TableCell align="left">
            {boardRoomCard && boardRoomCard.map((board, index) => (
              <Box key={index} mb={1}>
                <Typography variant="subtitle2">{board.duration}</Typography>
                {board.details.map((d, idx) => (
                  <Typography key={idx} variant="caption" display="block">- {d}</Typography>
                ))}
              </Box>
            ))}
          </TableCell>

          {/* ACTIONS */}
          <TableCell align="right">
            <HrconclaveMoreMenu
              onEdit={() => handleOpenModal(_id)}
              onDelete={() => handleDeleteHrconclave(_id)}
            />
          </TableCell>
        </TableRow>
      );
    })}

  {emptyRows > 0 && (
    <TableRow style={{ height: 53 * emptyRows }}>
      <TableCell colSpan={9} />
    </TableRow>
  )}
</TableBody>


                {isHrconclaveNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={hrconclaves.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

       <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
  <DialogTitle>
    {editingHrconclaveId ? 'Edit Rental Details' : 'New Rental Details'}
  </DialogTitle>

  <DialogContent>
    {/* Title and Subtitles */}
    <TextField
      margin="dense"
      label="Title"
      fullWidth
      value={title}
      onChange={(e) => setTitle(e.target.value)}
    />
    <TextField
      margin="dense"
      label="Subtitle 1"
      fullWidth
      value={subTitle1}
      onChange={(e) => setSubTitle1(e.target.value)}
    />
    <TextField
      margin="dense"
      label="Subtitle 2"
      fullWidth
      value={subTitle2}
      onChange={(e) => setSubTitle2(e.target.value)}
    />

    {/* Images */}
    <Box sx={{ mt: 2 }}>
      <TextField
        label="Add Image URL"
        fullWidth
        value={newImageLink}
        onChange={(e) => setNewImageLink(e.target.value)}
      />
      <Button variant="outlined" onClick={handleAddImageLink} sx={{ mt: 1 }}>
        Add Image
      </Button>
    </Box>
    <Box sx={{ mt: 1 }}>
      {images.map((img, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Typography variant="body2">{img}</Typography>
          <IconButton onClick={() => handleRemoveImageLink(index)}>
            <Iconify icon="eva:trash-2-outline" />
          </IconButton>
        </Box>
      ))}
    </Box>

    {/* Columns */}
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2">Columns</Typography>
      {columns.map((col, index) => (
  <Box key={index} sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
    <Box sx={{ flexGrow: 1 }}>
      <TextField
        label={`Group ${index + 1}`}
        value={col.group}
        onChange={(e) => {
          const updated = [...columns];
          updated[index].group = e.target.value;
          setColumns(updated);
        }}
        fullWidth
        margin="dense"
      />
      <TextField
        label="Sub-items (comma separated)"
        value={col.sub.join(', ')}
        onChange={(e) => {
          const updated = [...columns];
          updated[index].sub = e.target.value.split(',').map((s) => s.trim());
          setColumns(updated);
        }}
        fullWidth
        margin="dense"
      />
    </Box>
    <IconButton
      color="error"
      onClick={() => {
        const updated = [...columns];
        updated.splice(index, 1);
        setColumns(updated);
      }}
    >
      <Iconify icon="eva:trash-2-outline" />
    </IconButton>
  </Box>
))}
      <Button
        variant="outlined"
        onClick={() => setColumns([...columns, { group: '', sub: [] }])}
      >
        Add Column
      </Button>
    </Box>

    {/* Rows */}
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2">Rows</Typography>
    {rows.map((r, index) => (
  <Box key={index} sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
    <Box sx={{ flexGrow: 1 }}>
      <TextField
        label="Label"
        value={r.label}
        onChange={(e) => {
          const updated = [...rows];
          updated[index].label = e.target.value;
          setRows(updated);
        }}
        fullWidth
        margin="dense"
      />
      <TextField
        label="Values (comma separated)"
        value={r.values.join(', ')}
        onChange={(e) => {
          const updated = [...rows];
          updated[index].values = e.target.value.split(',').map((v) => v.trim());
          setRows(updated);
        }}
        fullWidth
        margin="dense"
      />
      <Checkbox
        checked={r.highlight || false}
        onChange={(e) => {
          const updated = [...rows];
          updated[index].highlight = e.target.checked;
          setRows(updated);
        }}
      /> Highlight
    </Box>
    <IconButton
      color="error"
      onClick={() => {
        const updated = [...rows];
        updated.splice(index, 1);
        setRows(updated);
      }}
    >
      <Iconify icon="eva:trash-2-outline" />
    </IconButton>
  </Box>
))}
      <Button variant="outlined" onClick={() => setRows([...rows, { label: '', values: [] }])}>
        Add Row
      </Button>
    </Box>

    {/* Card Data */}
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2">Hall Data</Typography>
    {cardData.map((card, index) => (
  <Box key={index} sx={{ mb: 1, border: '1px solid #ccc', p: 1, display: 'flex', alignItems: 'center' }}>
    <Box sx={{ flexGrow: 1 }}>
      <TextField
        label="Card Title"
        value={card.title}
        onChange={(e) => {
          const updated = [...cardData];
          updated[index].title = e.target.value;
          setCardData(updated);
        }}
        fullWidth
        margin="dense"
      />
      <TextField
        label="Items (comma separated)"
        value={card.items.join(', ')}
        onChange={(e) => {
          const updated = [...cardData];
          updated[index].items = e.target.value.split(',').map(i => i.trim());
          setCardData(updated);
        }}
        fullWidth
        margin="dense"
      />
    </Box>
    <IconButton
      color="error"
      onClick={() => {
        const updated = [...cardData];
        updated.splice(index, 1);
        setCardData(updated);
      }}
    >
      <Iconify icon="eva:trash-2-outline" />
    </IconButton>
  </Box>
))}
      <Button
        variant="outlined"
        onClick={() => setCardData([...cardData, { title: '', items: [] }])}
      >
        Add Card
      </Button>
    </Box>

    {/* Board Room Card */}
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2">Board Room Cards</Typography>
  {boardRoomCard.map((board, index) => (
  <Box key={index} sx={{ mb: 1, border: '1px solid #ccc', p: 1, display: 'flex', alignItems: 'center' }}>
    <Box sx={{ flexGrow: 1 }}>
      <TextField
        label="Duration"
        value={board.duration}
        onChange={(e) => {
          const updated = [...boardRoomCard];
          updated[index].duration = e.target.value;
          setBoardRoomCard(updated);
        }}
        fullWidth
        margin="dense"
      />
      <TextField
        label="Details (comma separated)"
        value={board.details.join(', ')}
        onChange={(e) => {
          const updated = [...boardRoomCard];
          updated[index].details = e.target.value.split(',').map(d => d.trim());
          setBoardRoomCard(updated);
        }}
        fullWidth
        margin="dense"
      />
    </Box>
    <IconButton
      color="error"
      onClick={() => {
        const updated = [...boardRoomCard];
        updated.splice(index, 1);
        setBoardRoomCard(updated);
      }}
    >
      <Iconify icon="eva:trash-2-outline" />
    </IconButton>
  </Box>
))}
      <Button
        variant="outlined"
        onClick={() => setBoardRoomCard([...boardRoomCard, { duration: '', details: [] }])}
      >
        Add Board Room Card
      </Button>
    </Box>
  </DialogContent>

  <DialogActions>
    <Button onClick={handleCloseModal}>Cancel</Button>
    {editingHrconclaveId ? (
      <Button onClick={handleUpdateHrconclave}>Update</Button>
    ) : (
      <Button onClick={handleAddHrconclave}>Create</Button>
    )}
  </DialogActions>
</Dialog>


        {/* View Modal */}
        <Dialog open={viewModalOpen} onClose={handleCloseViewModal} maxWidth="md" fullWidth>
  <DialogTitle>Rental Details</DialogTitle>
  <DialogContent>
    {selectedHrconclave && (
      <Box>
        {/* Title and Subtitles */}
        <TextField
          label="Title"
          value={selectedHrconclave.title}
          margin="dense"
          InputProps={{ readOnly: true }}
          fullWidth
        />
        <TextField
          label="Subtitle 1"
          value={selectedHrconclave.subTitle1}
          margin="dense"
          InputProps={{ readOnly: true }}
          fullWidth
        />
        <TextField
          label="Subtitle 2"
          value={selectedHrconclave.subTitle2}
          margin="dense"
          InputProps={{ readOnly: true }}
          fullWidth
        />

        {/* Images */}
        {selectedHrconclave.images && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2">Images:</Typography>
            {selectedHrconclave.images.map((img, index) => (
              <Typography key={index} variant="body2">
                <a href={img} target="_blank" rel="noopener noreferrer">{img}</a>
              </Typography>
            ))}
          </Box>
        )}

        {/* Columns */}
        {selectedHrconclave.columns && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2">Columns:</Typography>
            {selectedHrconclave.columns.map((col, index) => (
              <Box key={index} sx={{ mb: 1 }}>
                <Typography variant="body2"><strong>Group:</strong> {col.group}</Typography>
                <Typography variant="body2"><strong>Sub-items:</strong> {col.sub.join(', ')}</Typography>
              </Box>
            ))}
          </Box>
        )}

        {/* Rows */}
        {selectedHrconclave.rows && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2">Rows:</Typography>
            {selectedHrconclave.rows.map((row, index) => (
              <Box key={index} sx={{ mb: 1 }}>
                <Typography variant="body2"><strong>Label:</strong> {row.label}</Typography>
                <Typography variant="body2"><strong>Values:</strong> {row.values.join(', ')}</Typography>
                {row.highlight && <Typography variant="body2" color="primary">Highlight</Typography>}
              </Box>
            ))}
          </Box>
        )}

        {/* Card Data */}
        {selectedHrconclave.cardData && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2">Hall Data:</Typography>
            {selectedHrconclave.cardData.map((card, index) => (
              <Box key={index} sx={{ mb: 1 }}>
                <Typography variant="body2"><strong>Title:</strong> {card.title}</Typography>
                <Typography variant="body2"><strong>Items:</strong> {card.items.join(', ')}</Typography>
              </Box>
            ))}
          </Box>
        )}

        {/* Board Room Card */}
        {selectedHrconclave.boardRoomCard && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2">Board Room Cards:</Typography>
            {selectedHrconclave.boardRoomCard.map((board, index) => (
              <Box key={index} sx={{ mb: 1 }}>
                <Typography variant="body2"><strong>Duration:</strong> {board.duration}</Typography>
                <Typography variant="body2"><strong>Details:</strong> {board.details.join(', ')}</Typography>
              </Box>
            ))}
          </Box>
        )}

      </Box>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseViewModal}>Close</Button>
  </DialogActions>
</Dialog>

      </Container>
    </Page>
  );
}
